/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/dimensions/:dimension/actions" DataTable endpoint.
 * Fetches paginated actions for a specific dimension and transforms the response
 * from the paginated API format into the standard DataTable format ({ hits, results }).
 */
import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActions } from "./constants";
import type {
  DimensionActionsApiResponse,
  DecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsParams,
  GetDataTableDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsResult,
} from "./types";
import { isGetDataTableDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsResult } from "./validators";

export const getDataTableDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActions =
  reactQueryTableFetcherAdapter(
    decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActions,
    async (
      signal: AbortSignal,
      {
        appGroupId,
        dsaId,
        dimension,
        limit = 20,
        start = 0,
        query,
        environment,
      }: DecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsParams
    ): Promise<GetDataTableDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsResult> => {
      const queryParams: Record<string, unknown> = { limit, start };
      if (query?.search_term !== undefined) {
        queryParams.search_term = query.search_term;
      }
      if (query?.status !== undefined) {
        queryParams.status = query.status;
      }
      queryParams.environment = environment;

      const rawResponse = await fetch<DimensionActionsApiResponse>(
        `/decisioning_studio_agents/${appGroupId}/${dsaId}/dimensions/${dimension}/actions`,
        "GET",
        queryParams,
        { signal }
      );

      return {
        hits: rawResponse.meta.pagination.total,
        results: rawResponse.data,
      };
    },
    isGetDataTableDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsResult
  );
